import React from "react";
import { Field } from "formik";
import * as Yup from "yup";
import { isEmpty } from "lodash";

import Form from "components/form";
import { DatePicker, UserSelector, NoteInput, TextAreaInput, SelectInput } from "components/inputs";
import { StatusIcon } from "helpers/icon-finder";
import { getIPAAppealsTitle } from "utils/get-environment-variables";

const appealedByLabel = `${getIPAAppealsTitle().single}ed By`;
const appealDateLabel = `${getIPAAppealsTitle().single} Date`;
const notesLabel = "Notes";
const outcomeLabel = "Outcome";
const statusLabel = "Status";

const statusOptions = [
  { value: "Open", label: "Open" },
  { value: "Closed", label: "Closed" },
];

const schema = Yup.object().shape({
  appeal: Yup.object().shape({
    appealedBy: Yup.string()
      .max(255, `${appealedByLabel} can only be up to 255 characters.`)
      .required(`${appealedByLabel} is required`).nullable(),
    appealDate: Yup.date()
      .required(`${appealDateLabel} is required`).nullable(),
    status: Yup.string()
      .required(`${statusLabel} is required`).nullable(),
    outcome: Yup.string()
      .max(255, `${outcomeLabel} can only be up to 255 characters.`)
      .nullable(),
    notes: Yup.string()
      .max(4000, `${notesLabel} can only be up to 4000 characters.`)
      .nullable(),
  }),
});

const AppealForm = ({
  handleSubmit,
  applicationAppeal,
  orgUnitId,
  ...other
}) => {
  let { appeal } = schema.cast();
  if (!isEmpty(applicationAppeal)) {
    appeal = applicationAppeal;
  }

  return (
    <Form
      initialValues={{ appeal }}
      onSubmit={handleSubmit}
      contentProps={other}
      validationSchema={schema}
      content={() => (
        <>
          <Field
            name="appeal.appealDate"
            component={DatePicker}
            label={appealDateLabel}
            required
          />
          <Field
            name="appeal.appealedBy"
            component={UserSelector}
            label={appealedByLabel}
            icon="person"
            orgUnitId={orgUnitId}
            required
          />
          <Field
            name="appeal.status"
            icon={<StatusIcon />}
            component={SelectInput}
            options={statusOptions}
            label={statusLabel}
            required
          />
          <Field
            name="appeal.outcome"
            icon="list_alt"
            component={TextAreaInput}
            label={outcomeLabel}
            maxLength={255}
          />
          <Field
            name="appeal.notes"
            component={NoteInput}
            label={notesLabel}
            maxLength={4000}
          />
        </>
      )}
    />
  );
};

export default AppealForm;
